import { ReactComponent as AboutHKDCIconSVG } from "./about-hkdc.svg";
import { SvgIcon } from '@mui/material';

export default function IconAboutHKDC(props) {
  return <SvgIcon {...props} component={AboutHKDCIconSVG} viewBox="0 0 758.25 551" />;
}